import { render, staticRenderFns } from "./humanSensor.vue?vue&type=template&id=f14c017c&scoped=true"
import script from "./humanSensor.vue?vue&type=script&lang=js"
export * from "./humanSensor.vue?vue&type=script&lang=js"
import style0 from "./humanSensor.vue?vue&type=style&index=0&id=f14c017c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f14c017c",
  null
  
)

export default component.exports